import { FC } from "react";
import { UploadIcon } from "lucide-react-native";

import { VnButton } from "@/components/VnButton/VnButton";
import { VnIcon } from "@/components/VnIcon";
import { VnText } from "@/components/VnText/VnText";
import { I18nKeyType } from "@/i18n";
import { cn } from "@/utils/tailwind";

type UploadButtonPropsType = {
  onPress: () => void;
  isUploading: boolean;
  titleI18nKey?: I18nKeyType;
  className?: string;
};

export const UploadButton: FC<UploadButtonPropsType> = ({
  onPress,
  isUploading,
  titleI18nKey = "common:uploadButton.title",
  className,
}) => {
  return (
    <VnButton
      variant="secondary"
      onPress={onPress}
      disabled={isUploading}
      className={cn(
        "bg-secondary border-input flex-row items-center justify-center gap-3 rounded-md border p-4",
        isUploading && "opacity-50",
        className,
      )}>
      <VnIcon as={UploadIcon} size={20} className="text-foreground" />
      <VnText variant="mdMedium" i18nKey={titleI18nKey} />
    </VnButton>
  );
};
